import React, { useCallback, useEffect } from "react";
import "./App.less";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import faIR from "antd/es/locale/fa_IR";
import Login from "./pages/Login";
import Home from "./pages/Home";
import { useAppDispatch, useAppSelector } from "../application/store";
import { checkAuthentication } from "../application/auth-slice";
import NotFound from "./pages/NotFound";

const HomeRoute = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  if (isAuthenticated === "authenticated") return <Home />;
  return <Redirect to={"/login"} />;
};

export default function App() {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(checkAuthentication());
  }, [stableDispatch]);

  return (
    <ConfigProvider locale={faIR} direction="rtl" componentSize="large">
      <BrowserRouter>
        {isAuthenticated === "initial" ? (
          <Spin />
        ) : (
          <Switch>
            <Route
              path="/:activeTab(|orders|products|new-product|edit-product|categories|discounts|new-discount|home-settings|settings|colors)"
              component={HomeRoute}
              exact
            />
            <Route path="/login" component={Login} exact />
            <Route component={NotFound} />
          </Switch>
        )}
      </BrowserRouter>
    </ConfigProvider>
  );
}
